import { Button } from "@headlessui/react";
import { CSSProperties } from "react";

export const ConfirmButton = ({
  children,
  className,
  onClick,
  disabled,
  style = {},
  type = "button",
  otherProps,
  "data-testid": dataTestId,
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: Function;
  disabled?: any;
  otherProps?: any;
  style?: CSSProperties;
  type?: "button" | "submit" | "reset";
  "data-testid"?: string;
}) => (
  <Button
    type={type}
    data-testid={dataTestId}
    className={`py-2 px-8 rounded bg-[var(--merchant-color)] text-white data-[hover]:bg-blend-darken data-[active]:bg-blend-darken ${className}`}
    onClick={onClick}
    style={style}
    {...otherProps}
    disabled={disabled}
  >
    {children}
  </Button>
);
